var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcademyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.987,
    height: 26.987,
    viewBox: "0 0 26.987 26.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    transform: "translate(-51.93 -15.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(51.93 15.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M188.463,177.7c0-.014-.005-.029-.008-.043a13.494,13.494,0,0,0-26.51,0c0,.014-.006.028-.008.043a13.486,13.486,0,0,0,5.129,13.244c.025.022.049.044.075.064a1.378,1.378,0,0,0,.129.087,13.463,13.463,0,0,0,15.858,0c.038-.023.076-.048.113-.075s.073-.058.107-.089a13.486,13.486,0,0,0,5.116-13.234Zm-11.833-8.048a10.662,10.662,0,0,1,8.554,6.879h-4.569l-3.986-2.9Zm2.276,9.174-1.416,4.357h-4.582l-1.416-4.357,3.707-2.693Zm-5.137-9.174v3.983l-3.986,2.9h-4.569A10.662,10.662,0,0,1,173.769,169.651Zm-9.2,10.533c0-.267.013-.531.033-.793h4.068l1.663,5.117-2.534,3.3A10.6,10.6,0,0,1,164.567,180.185ZM175.2,190.817a10.567,10.567,0,0,1-5.1-1.308l2.664-3.465h5l2.562,3.452A10.564,10.564,0,0,1,175.2,190.817Zm7.421-3.029L180.1,184.4l1.627-5.006H185.8c.019.262.033.526.033.793A10.6,10.6,0,0,1,182.621,187.788Z",
    transform: "translate(-161.706 -166.691)",
    fill: "current"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademyIcon);
export default __webpack_public_path__ + "static/media/academyIcon.606ac33b.svg";
export { ForwardRef as ReactComponent };